function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import ActiveNotingLabel from 'components/ActiveNotingLabel';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import App from 'modules/App';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import Button from 'components/Form/Button';
import Widget from 'components/Widget';
import intlShape from 'shapes/intlShape';
import { ContinuousConcentrationTrend, GlucoseConcentrationTrend } from 'modules/PatientResults/modules/Charts';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../Results/Results.pcss';
var _React_PureComponent;
class TrendChartWidget extends (_React_PureComponent = React.PureComponent) {
    onAddNote(timestamp, value, standardDeviation, unitSymbol, status) {
        const { mode, aggregateBy, calculationFormula } = this.props;
        let noteType = 'Reading';
        let start = timestamp;
        let end;
        let titleMessage = messages.labels.glucoseConcentration;
        if (mode === 'AGGREGATED') {
            noteType = upperFirst(camelCase(calculationFormula));
            titleMessage = messages.formulas[camelCase(calculationFormula)];
            const tsMoment = moment.unix(timestamp).utc().locale('en--account');
            if (calculationFormula === 'HYPERGLYCEMIA') status = 'high';
            else if (calculationFormula === 'HYPOGLYCEMIA') status = 'low';
            if (aggregateBy === 'DAY') {
                start = +tsMoment.clone().startOf('day').format('X');
            } else if (aggregateBy === 'WEEK') {
                start = +tsMoment.clone().startOf('week').format('X');
                end = +tsMoment.clone().endOf('week').format('X');
            } else if (aggregateBy === 'MONTH') {
                start = +tsMoment.clone().startOf('month').format('X');
                end = +tsMoment.clone().endOf('month').format('X');
            }
        }
        this.props.onAddNote(noteType, {
            value,
            standardDeviation,
            unitSymbol,
            status,
            start,
            end,
            titleMessage
        });
    }
    onToggleJoinPoints() {
        this.props.onSetIsLineEnabled(!this.props.isTrendChartLineEnabled);
    }
    get ticks() {
        const { mode, aggregateBy, groupBy, start, end } = this.props;
        if (!start || !end) {
            return [];
        }
        if (mode === 'ALL') {
            return null;
        }
        if (mode === 'AGGREGATED') {
            if (aggregateBy === 'DAY') {
                return null;
            }
            const startDate = moment.unix(start).utc().locale('en--account');
            const endDate = moment.unix(end).utc().locale('en--account');
            const ticks = [];
            const unit = aggregateBy.toLowerCase();
            startDate.startOf(unit);
            endDate.endOf(unit);
            const difference = endDate.diff(startDate, unit, false);
            const interval = Math.max(Math.ceil(difference / 14), 1);
            ticks.push(+startDate.format('X'));
            while(startDate.isBefore(endDate)){
                startDate.add(interval, unit);
                ticks.push(+startDate.format('X'));
            }
            return ticks;
        }
        if (mode === 'GROUPED') {
            const startDate = moment().utc().locale('en--account');
            const endDate = moment().utc().locale('en--account');
            const ticks = [];
            let unit = 'day';
            switch(groupBy){
                case 'WEEKDAY':
                    {
                        startDate.startOf('week');
                        endDate.endOf('week');
                        break;
                    }
                case 'MONTH':
                case 'QUARTER':
                    {
                        startDate.startOf('year');
                        endDate.endOf('year');
                        unit = groupBy.toLowerCase();
                        break;
                    }
                case 'HOURS_RANGE':
                    {
                        startDate.startOf('day');
                        endDate.endOf('day');
                        unit = 'hour';
                        ticks.push(+startDate.format('X'));
                        const breakpoints = [
                            ...this.props.customRanges
                        ];
                        breakpoints.shift();
                        forEach(breakpoints, (hourBreakpoint)=>{
                            ticks.push(+startDate.hour(hourBreakpoint[0]).minutes(hourBreakpoint[1]).format('X'));
                        });
                        ticks.push(+endDate.format('X') + 1);
                        return ticks;
                    }
                default:
                    {
                        break;
                    }
            }
            ticks.push(+startDate.format('X'));
            while(startDate.isBefore(endDate)){
                startDate.add(1, unit);
                ticks.push(+startDate.format('X'));
            }
            return ticks;
        }
        return null;
    }
    get isCustomRanges() {
        const { mode, groupBy } = this.props;
        return mode === 'GROUPED' && groupBy === 'HOURS_RANGE';
    }
    formatLabel(value, firstTick, lastTick) {
        const { mode, aggregateBy, groupBy, intl } = this.props;
        const momentDate = moment.unix(value).utc();
        if (mode === 'ALL') {
            return momentDate.format('L');
        }
        if (mode === 'AGGREGATED') {
            if (aggregateBy === 'DAY') {
                return momentDate.format('L');
            }
            if (aggregateBy === 'WEEK') {
                momentDate.endOf('week');
                return intl.formatMessage(messages.chartLabels.week, {
                    week: momentDate.format('wo'),
                    year: momentDate.format('YYYY')
                });
            }
            if (aggregateBy === 'MONTH') {
                return `${momentDate.format('MMMM')} ${momentDate.format('YYYY')}`;
            }
        }
        if (mode === 'GROUPED') {
            if (value === lastTick) {
                return '';
            }
            if (groupBy === 'WEEKDAY') {
                return momentDate.format('dddd');
            }
            if (groupBy === 'MONTH') {
                return momentDate.format('MMMM');
            }
            if (groupBy === 'QUARTER') {
                return intl.formatMessage(messages.chartLabels.quarter, {
                    quarter: momentDate.format('Qo')
                });
            }
            if (groupBy === 'HOURS_RANGE') {
                return '';
            }
        }
        return momentDate.format('L');
    }
    renderTick(tickProps, xGap) {
        const { mode, groupBy, direction } = this.props;
        const { value, x, y, textX, textY, rotate, textAnchor, textBaseline, format } = tickProps;
        const formattedValue = format(value);
        let valueComponent = formattedValue;
        if (mode === 'GROUPED' && [
            'WEEKDAY',
            'MONTH',
            'QUARTER'
        ].includes(groupBy)) {
            const xSpan = `${direction === 'rtl' ? '-' : ''}${xGap / 2}`;
            valueComponent = /*#__PURE__*/ _jsx("tspan", {
                x: xSpan,
                children: formattedValue
            });
        }
        return /*#__PURE__*/ _jsx("g", {
            transform: `translate(${x},${y})`,
            style: {
                opacity: 1
            },
            children: /*#__PURE__*/ _jsx("text", {
                dominantBaseline: textBaseline,
                textAnchor: textAnchor,
                transform: `translate(${textX},${textY}) rotate(${rotate})`,
                style: {
                    fontFamily: 'sans-serif',
                    fontSize: '11px',
                    fill: 'rgb(51, 51, 51)'
                },
                children: valueComponent
            })
        });
    }
    renderJoinOptions() {
        const { mode, isTrendChartLineEnabled, isInProgress, printMode } = this.props;
        if (mode === 'GROUPED' || printMode) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "btn-group col-auto",
            children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                id: "joinPoints",
                inputValue: "true",
                value: isTrendChartLineEnabled ? isTrendChartLineEnabled.toString() : 'false',
                labelMessage: messages.buttons.joinPoints,
                className: styles.joinPointsCheckbox,
                onChange: ()=>this.onToggleJoinPoints(),
                isDisabled: isInProgress
            })
        });
    }
    renderPresentationTypes() {
        const { isInProgress } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "form-label",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.presentationTypes))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "btn-group col-auto",
                            children: map(constants.MODES, (mode)=>/*#__PURE__*/ _jsx(Button, {
                                    styleModifier: "quaternary",
                                    className: cn('btn--filled', {
                                        'text--primary': mode === this.props.mode
                                    }),
                                    labelMessage: messages.buttons[mode.toLowerCase()],
                                    isDisabled: isInProgress,
                                    onClick: ()=>this.props.onSetMode(mode)
                                }, mode))
                        }),
                        this.props.featureToggles.includes(App.constants.FEATURE_TOGGLES.featureCgm) && /*#__PURE__*/ _jsx("div", {
                            className: "btn-group col-auto",
                            children: map(constants.DEVICES_MODES, (mode)=>/*#__PURE__*/ _jsx(Button, {
                                    styleModifier: "quaternary",
                                    className: cn('btn--filled', {
                                        'text--primary': mode === this.props.deviceMode
                                    }),
                                    labelMessage: messages.buttons[mode.toLowerCase()],
                                    isDisabled: isInProgress,
                                    onClick: ()=>this.props.onSetDeviceMode(mode)
                                }, mode))
                        })
                    ]
                })
            ]
        });
    }
    renderCalculationFormulas() {
        const { mode, calculationFormula, isInProgress, intl } = this.props;
        const calculationFormulas = [
            ...constants.CALCULATION_FORMULAS
        ];
        if (mode === 'AGGREGATED') {
            calculationFormulas.shift();
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "calculationFormula",
            labelMessage: messages.labels.calculationFormula,
            className: styles.sortOptions__option,
            formValues: {
                values: {
                    calculationFormula
                }
            },
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: map(calculationFormulas, (formula)=>({
                        value: formula,
                        label: intl.formatMessage(messages.formulas[camelCase(formula)])
                    })),
                valueKey: "value",
                labelKey: "label",
                isDisabled: isInProgress,
                onChange: (input)=>this.props.onSetCalculationFormula(input.value)
            })
        });
    }
    renderAggregateBy() {
        const { mode, aggregateBy, isInProgress, intl } = this.props;
        if (mode !== 'AGGREGATED') {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "aggregateBy",
            labelMessage: messages.labels.aggregateBy,
            className: styles.sortOptions__option,
            formValues: {
                values: {
                    aggregateBy
                }
            },
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: map(constants.AGGREGATE_BY, (unit)=>({
                        value: unit,
                        label: intl.formatMessage(messages.aggregateBy[unit.toLowerCase()])
                    })),
                valueKey: "value",
                labelKey: "label",
                isDisabled: isInProgress,
                onChange: (input)=>this.props.onSetAggregateBy(input.value)
            })
        });
    }
    renderGroupBy() {
        const { mode, groupBy, isInProgress, intl } = this.props;
        if (mode !== 'GROUPED') {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "groupBy",
            labelMessage: messages.labels.groupBy,
            className: styles.sortOptions__option,
            formValues: {
                values: {
                    groupBy
                }
            },
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: map(constants.GROUP_BY, (type)=>({
                        value: type,
                        label: intl.formatMessage(messages.groupBy[type.toLowerCase()])
                    })),
                valueKey: "value",
                labelKey: "label",
                isDisabled: isInProgress,
                onChange: (input)=>this.props.onSetGroupBy(input.value)
            })
        });
    }
    renderPresentationOptions() {
        if (this.props.mode === 'ALL') {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "d-flex justify-content-end",
            children: [
                this.renderCalculationFormulas(),
                this.renderAggregateBy(),
                this.renderGroupBy()
            ]
        });
    }
    renderFilters() {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.chartControls__filters, styles.chartControls__wrapper, 'row'),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-auto mb-4",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "form-label",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.periodWithResults))
                        }),
                        this.props.renderDatePresets()
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-auto mb-4",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "form-label",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.flagsFilters))
                        }),
                        this.props.renderFlagFilters()
                    ]
                })
            ]
        });
    }
    renderChartControls() {
        const { printMode, renderControls } = this.props;
        if (printMode || !renderControls) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.chartControls, {
                fadingLoader: this.props.isInProgress
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto mb-4",
                            children: this.renderPresentationTypes()
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto mb-4",
                            children: this.renderPresentationOptions()
                        })
                    ]
                }),
                this.renderFilters()
            ]
        });
    }
    renderUnit(conversion) {
        const { calculationFormula } = this.props;
        let unit = conversion.unitSymbol;
        switch(calculationFormula){
            case 'HYPOGLYCEMIA':
            case 'HYPERGLYCEMIA':
                unit = App.constants.UNITS_SYMBOLS.PERCENT;
                break;
            case 'COUNT':
                unit = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.unitCount));
                break;
            default:
                break;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: styles.bloodGlucoseConcentrationUnit,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.unit), {
                values: {
                    unit
                }
            }))
        });
    }
    renderActiveNotingLabel() {
        if (!this.props.onAddNote) {
            return null;
        }
        return /*#__PURE__*/ _jsx(ActiveNotingLabel, {
            labelMessage: messages.noting.clickPoint
        });
    }
    render() {
        const { data, dataType, mode, calculationFormula, start, end, conversion, className, isReadOnly, printMode, isTrendChartLineEnabled, measurements, relatedData, timeSeriesResources, aggregateBy, groupBy, intl, isInProgress } = this.props;
        const { ticks, isCustomRanges } = this;
        let headerAdditionalMessage = '';
        switch(mode){
            case 'GROUPED':
                headerAdditionalMessage = ` ${intl.formatMessage(messages.formulas[camelCase(calculationFormula)])},
        ${intl.formatMessage(messages.groupBy[groupBy.toLowerCase()])}`;
                break;
            case 'AGGREGATED':
                headerAdditionalMessage = ` ${intl.formatMessage(messages.formulas[camelCase(calculationFormula)])},
          ${intl.formatMessage(messages.aggregateBy[aggregateBy.toLowerCase()])}`;
                break;
            default:
                break;
        }
        return /*#__PURE__*/ _jsxs(Widget, {
            widgetId: constants.TREND_CHART_WIDGET,
            headerMessage: messages.headers.bloodGlucoseConcentration,
            headerAdditionalMessage: headerAdditionalMessage,
            className: className,
            headerAdditionalMessageClassName: "widget__header__additional__bold",
            style: {
                height: printMode ? '343px' : 'auto'
            },
            children: [
                this.renderActiveNotingLabel(),
                this.renderChartControls(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex justify-content-between align-items-center",
                    children: [
                        this.renderUnit(conversion),
                        this.renderJoinOptions()
                    ]
                }),
                dataType === 'CGM' ? /*#__PURE__*/ _jsx(ContinuousConcentrationTrend, {
                    readings: data,
                    start: start,
                    end: end,
                    isInProgress: isInProgress,
                    isReadOnly: isReadOnly,
                    updatePhiSet: this.props.onUpdatePhiSet
                }) : /*#__PURE__*/ _jsx(GlucoseConcentrationTrend, {
                    readings: data,
                    dataType: dataType,
                    start: start,
                    end: end,
                    ticks: ticks,
                    isInProgress: isInProgress,
                    isReadOnly: isReadOnly,
                    measurements: measurements,
                    relatedData: relatedData,
                    timeSeriesResources: timeSeriesResources,
                    isCustomRanges: isCustomRanges,
                    isLineEnabled: mode !== 'GROUPED' && isTrendChartLineEnabled,
                    isGridXEnabled: mode === 'GROUPED' && (!isCustomRanges || isReadOnly),
                    showRelatedData: mode !== 'GROUPED',
                    formatLabel: (value, firstTick, lastTick)=>this.formatLabel(value, firstTick, lastTick),
                    renderTick: (tickProps, xGap)=>this.renderTick(tickProps, xGap),
                    updatePhiSet: this.props.onUpdatePhiSet,
                    addNote: this.props.onAddNote ? (...props)=>this.onAddNote(...props) : null
                })
            ]
        });
    }
}
_define_property(TrendChartWidget, "propTypes", {
    // Explicit props
    data: PropTypes.array.isRequired,
    dataType: PropTypes.string,
    start: PropTypes.number,
    end: PropTypes.number,
    conversion: PropTypes.object.isRequired,
    direction: PropTypes.string.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }).isRequired,
    customRanges: PropTypes.array,
    renderDatePresets: PropTypes.func,
    renderFlagFilters: PropTypes.func,
    className: PropTypes.string,
    isReadOnly: PropTypes.bool,
    isInProgress: PropTypes.bool,
    renderControls: PropTypes.bool,
    relatedData: PropTypes.array,
    timeSeriesResources: PropTypes.array,
    measurements: PropTypes.array,
    // Explicit actions
    onUpdatePhiSet: PropTypes.func,
    onAddNote: PropTypes.func,
    // Implicit props
    mode: PropTypes.oneOf(constants.MODES),
    deviceMode: PropTypes.oneOf(constants.DEVICES_MODES),
    calculationFormula: PropTypes.oneOf([
        ...constants.CALCULATION_FORMULAS,
        ...constants.CALCULATION_FORMULAS_CGM
    ]),
    aggregateBy: PropTypes.oneOf(constants.AGGREGATE_BY),
    groupBy: PropTypes.oneOf([
        ...constants.GROUP_BY,
        ...constants.GROUP_BY_CGM
    ]),
    isTrendChartLineEnabled: PropTypes.bool,
    intl: intlShape,
    printMode: PropTypes.bool,
    featureToggles: PropTypes.arrayOf(PropTypes.string),
    // Implicit actions
    onSetMode: PropTypes.func,
    onSetDeviceMode: PropTypes.func,
    onSetCalculationFormula: PropTypes.func,
    onSetAggregateBy: PropTypes.func,
    onSetGroupBy: PropTypes.func,
    onSetIsLineEnabled: PropTypes.func
});
const mapStateToProps = (state)=>({
        mode: selectors.mode(state),
        deviceMode: selectors.deviceMode(state),
        calculationFormula: selectors.calculationFormula(state),
        aggregateBy: selectors.aggregateBy(state),
        groupBy: selectors.groupBy(state),
        isTrendChartLineEnabled: selectors.isTrendChartLineEnabled(state),
        printMode: App.selectors.printMode(state),
        featureToggles: App.selectors.featureToggles(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSetMode: (mode)=>dispatch(actions.setMode(mode)),
        onSetDeviceMode: (deviceMode)=>dispatch(actions.setDeviceMode(deviceMode)),
        onSetCalculationFormula: (calculationFormula)=>dispatch(actions.setCalculationFormula(calculationFormula)),
        onSetAggregateBy: (aggregateBy)=>dispatch(actions.setAggregateBy(aggregateBy)),
        onSetGroupBy: (groupBy)=>dispatch(actions.setGroupBy(groupBy)),
        onSetIsLineEnabled: (isEnabled)=>dispatch(actions.setIsTrendChartLineEnabled(isEnabled))
    });
const ConnectedTrendChartWidget = connect(mapStateToProps, mapDispatchToProps)(injectIntl(TrendChartWidget));
export default ConnectedTrendChartWidget;
